import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertIcoToJpg() {
  return (
    <ImageConverterTemplate
      sourceFormat="ICO"
      targetFormat="JPG"
      acceptTypes=".ico,image/x-icon,image/vnd.microsoft.icon"
      slug="convert-ico-to-jpg"
      gradientColors="from-cyan-500 to-orange-500"
      accentColor="orange"
      showQualitySlider={true}
    />
  );
}
